import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { AppBar, Box } from '@mui/material';
import { useUser } from 'shared/hooks';
import { InsightLogo } from '../logos';
import ServiceDeskLink from '../ServiceDeskLink';
import { ColoredToolbar } from './colored-toolbar';
import { UserMenu } from './user-menu';

export function Header() {
  const { instance } = useMsal();
  const authenticated = useIsAuthenticated();
  const user = useUser();

  if (!user) {
    return null;
  }
  return (
    <AppBar position='sticky'>
      <ColoredToolbar>
        <Box display='flex' flex='1'>
          <InsightLogo />
        </Box>
        <Box display='flex' flex='1'></Box>
        {authenticated && (
          <Box display='flex' flex='1' justifyContent='end'>
            {authenticated && (
              <Box justifyContent='end' display='flex'>
                <ServiceDeskLink />
                <UserMenu
                  logout={() => {
                    instance.logout();
                  }}
                  user={user}
                />
              </Box>
            )}
          </Box>
        )}
      </ColoredToolbar>
    </AppBar>
  );
}
